<template>
  <td>
    <button class="k-primary k-button k-grid-edit-command" @click="clickHandler">Acknowledge</button>
  </td>
</template>
 
<script>
export default {
  props: {
    dataItem: Object,
    columnIndex: Number
  },
  watch: {
    dataItem: function(newVal) {
      this.item = newVal;
    }
  },
  methods: {
    clickHandler: function() {
      this.$emit("Acknowledge", { dataItem: this.item });
    }
  },
  data: function() {
    return {
      item: { ...this.dataItem }
    };
  }
};
</script>
 
<style>
</style>
